import DotsAnimation from './DotsAnimation';
export default DotsAnimation;